module.exports = __webpack_public_path__ + "static/home-banner2-min-9761a6817e437a452253c9bcf63bd61c.png";